import React from 'react';
class Author extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      URL: '',
      iconURL: ''
    };
  }

  updateName(event) {
    this.setState({
      name: event.target.value
    });
  }

  updateURL(event) {
    this.setState({
      URL: event.target.value
    });
  }

  updateIconURL(event) {
    this.setState({
      iconURL: event.target.value
    });
  }

  render() {
    return(
      <div className = "embed-group embed-author">
        <div className = "embed-author-icon">
          <input
            type = "url"
            name = "author:icon_url"
            placeholder = "Author Icon URL"
            value = {this.state.iconURL}
            onChange = {event => this.updateIconURL(event)}
          />
        </div>
        <div className="embed-author-name">
          <input
            type = "text"
            name = "author:name"
            placeholder = "Author Name"
            maxLength = "256"
            value = {this.state.name}
            onChange = {event => this.updateName(event)}
          />
        </div>
        <div className="embed-author-url">
          <input
            type = "url"
            name = "author:url"
            placeholder = "Author URL"
            value = {this.state.URL}
            onChange = {event => this.updateURL(event)}
          />
        </div>
      </div>
    );
  }
}

export default Author;
